'use client';

import React__default, { useCallback } from 'react';
import Popup from '../Popup/index.js';
import { ELanguage } from '../Utils/constants.js';
import { translations } from './translations.js';
import StarBurstIcon from '../Images/StarBurstIcon/index.js';
import { CTAWrapper, AIBeforeApplyContainer, ImageWrapper, ListWrapper, AIBeforeApplyTypo } from './AIBeforeApply.css.js';
import Typography from '../Typography/index.js';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';
import Button from '../Button/index.js';
import ButtonAI from '../ButtonAI/index.js';

var AIBeforeApply = function (props) {
    var imageUrl = props.imageUrl, langCode = props.langCode, onContinueApply = props.onContinueApply, onViewAnalysis = props.onViewAnalysis;
    var _a = props.showState, isShow = _a[0], setIsShow = _a[1];
    var t = useCallback(function (text) {
        var _a;
        if (langCode === ELanguage.VI) {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [langCode]);
    return (React__default.createElement(Popup, { isShow: isShow, lang: langCode, styleOption: {
            size: 'md',
            headerBg: 'linear-gradient(269deg, #B900F6 0.91%, #DC1EAF 23.38%, #FF6200 45.85%, #FDB92E 92.62%)',
            headerTextColor: '#fff',
            isHaveBorder: false,
            closeIconColor: '#fff'
        }, custom: {
            footer: (React__default.createElement(CTAWrapper, null,
                React__default.createElement(Row, { gutter: [0, 8], justify: 'end' },
                    React__default.createElement(Col, { xs: 'auto' },
                        React__default.createElement(Button, { type: 'ai', outline: 'outline', onClick: function () { return onViewAnalysis && onViewAnalysis(); } }, t('View analysis to maximize now'))),
                    React__default.createElement(Col, { xs: 'auto' },
                        React__default.createElement(ButtonAI, { onClick: function () { return onContinueApply && onContinueApply(); } }, t('Continue applying'))))))
        }, text: {
            header: t('Do you want to maximize your competitive advantage before applying?')
        }, onClickOutside: function () { return setIsShow(false); }, onClose: function () { return onContinueApply && onContinueApply(); } },
        React__default.createElement(AIBeforeApplyContainer, null,
            React__default.createElement(ImageWrapper, null,
                React__default.createElement("img", { src: "".concat(imageUrl, "/images/AI-review-before-apply.png"), alt: t('Maximize your competitive advantage with VietnamWorks AI before applying') })),
            React__default.createElement(ListWrapper, null,
                React__default.createElement(Typography, { name: 'body', size: 'large', style: { marginBottom: '16px' } }, t('Maximize your competitive advantage with VietnamWorks AI before applying')),
                React__default.createElement("ul", { className: 'list' },
                    React__default.createElement("li", null,
                        React__default.createElement(StarBurstIcon, null),
                        ' ',
                        React__default.createElement(Typography, { name: 'body', size: 'large' }, t("Assess matching rate from employer's viewpoint"))),
                    React__default.createElement("li", null,
                        React__default.createElement(StarBurstIcon, null),
                        ' ',
                        React__default.createElement(Typography, { name: 'body', size: 'large' }, t('Suggest to improve the matching'))),
                    React__default.createElement("li", null,
                        React__default.createElement(StarBurstIcon, null),
                        ' ',
                        React__default.createElement(Typography, { name: 'body', size: 'large' }, t('Analyze the profiles of applicants'))),
                    React__default.createElement("li", null,
                        React__default.createElement(StarBurstIcon, null),
                        ' ',
                        React__default.createElement(Typography, { name: 'body', size: 'large' }, t('Check salary reference and hiring demand')))),
                React__default.createElement(AIBeforeApplyTypo, { size: 'large', name: 'body' },
                    t('Explore the'),
                    " ",
                    React__default.createElement("span", null, t('Competitive analysis report')),
                    ' ',
                    t('now to get closer to your dream job!'))))));
};

export { AIBeforeApply as default };
//# sourceMappingURL=index.js.map
